import { darkLogoUrl } from '../../utils';

import { history } from '../../store';

const LogoComponent = () => {
  const openHomePage = () => history.push('/');

  return (
    <div
      style={{
        height: '8rem',
        padding: '0.5rem',
        cursor: 'pointer',
      }}
      onClick={openHomePage}
      onKeyPress={openHomePage}
      role="button"
      tabIndex="0"
    >
      <img
        style={{
          height: '100%',
        }}
        src={darkLogoUrl}
        alt="Carson Logo"
      />
    </div>
  );
};

export default LogoComponent;
